import React from 'react'
import './contacthero.less'

export default ()=>{
    return(
        <section className="contact-hero">
            <h1>
                Contact Us
            </h1>
        </section>
    )
}